import { render, staticRenderFns } from "./AffiliateList.vue?vue&type=template&id=28d1f8ec&scoped=true"
import script from "./AffiliateList.vue?vue&type=script&lang=js"
export * from "./AffiliateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d1f8ec",
  null
  
)

export default component.exports